import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

import Skeleton from 'react-loading-skeleton';

function snapshotExists(snap) {
  return typeof snap.exists === 'function' ? snap.exists() : snap.exists;
}

const AdminRoute = ({ children }) => {
  
  const [user, loadingAuth] = useAuthState(auth);
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    if (!user) {
      setAllowed(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'admins', user.uid));
        if (!cancelled) setAllowed(snapshotExists(snap));
      } catch {
        if (!cancelled) setAllowed(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (loadingAuth || (user && allowed === null)) {
    return (
      <div className="container mt-5 p-0">
        <Skeleton height={48} className="mb-4" borderRadius={12} />
        <Skeleton height={280} borderRadius={12} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={'/login'} replace />;
  }

  if (!allowed) {
    return <Navigate to={'/'} replace />;
  }

  return children;
};

export default AdminRoute;
